import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import App from './App'
import { HashRouter } from 'react-router-dom'
import ScrollToTop from './components/ScrollToTop'

ReactDOM.render(
	<HashRouter>
		<ScrollToTop />
		<App />
	</HashRouter>,
	document.getElementById('root')
)



// WEBPACK FOOTER //
// ./src/index.js